import React from 'react';
import Immutable from 'immutable';

import WebformActions from '@uncinc/react-drupal-core/dist/Components/Webform/WebformActions';
import WebformContainer from '@uncinc/react-drupal-core/dist/Components/Webform/WebformContainer';
import WebformMapper from '@uncinc/react-drupal-core/dist/Components/Webform/WebformMapper';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import withTransitions from '../../../../context/withTransitions';
import type { WebformWizardPage } from '../../types';

interface CustomImmutableEntity<T> extends ImmutableEntity<T> {
  entrySeq: Immutable.Map<string, CustomImmutableEntity<T>>['entrySeq'];
  keySeq: Immutable.Map<string, CustomImmutableEntity<T>>['keySeq'];
  delete: Immutable.Map<string, CustomImmutableEntity<T>>['delete'];
}

export interface WebformWizardPageInnerProps {
  entity: CustomImmutableEntity<WebformWizardPage>;
  currentPage: string;
  pages: Immutable.Map<string, string>;
  showActions: boolean;
  isCurrentPage: boolean;
}

const hasPageActions = (entity: WebformWizardPageInnerProps['entity'], currentPage: WebformWizardPageInnerProps['currentPage']) => {
  let objectFound: WebformWizardPageInnerProps['entity'] | undefined;

  // Check on type 'webform_actions' and if these are actions for this page.
  entity.entrySeq().forEach(([key, element]) => {
    if (key.indexOf('#') !== 0) {
      if (element.get('#type') === 'webform_actions' && element.get('#webform_parent_key') === currentPage) {
        objectFound = element;
      }

      // Recursively loop over children if we have not found.
      if (!objectFound) {
        let currentChildren = element;

        element.keySeq().forEach((k) => {
          if (k.indexOf('#') === 0) {
            // @ts-expect-error
            currentChildren = currentChildren.delete(k);
          }
        });

        objectFound = hasPageActions(currentChildren, currentPage);
      }
    }
  });

  return objectFound;
};

const WebformWizardPageInner: React.FC<WebformWizardPageInnerProps> = (props) => {
  const {
    entity,
    currentPage,
    showActions,
  } = props;

  const pageAction = hasPageActions(entity, currentPage);

  return (
    <div className="WebformWizardPage">
      {entity.get('#format') !== 'container' && (
        <h2 className="WebformWizardPage__title">
          {entity.get('#admin_title')}
        </h2>
      )}

      <div className="WebformWizardPage__divider" />

      <WebformContainer {...props} WebformMapper={WebformMapper} />

      {(showActions && !pageAction) && (
        <div className="WebformWizardPage__actions">
          <WebformActions
            {...props}
            key={`submit${currentPage}`}
            entity={Immutable.Map({
              '#type': 'webform_actions',
              '#wizard_prev__label': entity.get('#prev_button_label'),
              '#wizard_next__label': entity.get('#next_button_label'),
              '#webform': currentPage,
              '#webform_id': `${currentPage}--actions`,
              '#webform_key': 'actions',
              '#webform_plugin_id': 'webform_actions',
            })}
          />
        </div>
      )}
    </div>
  );
};

export const WebformWizardPageInnerAnimated = withTransitions(WebformWizardPageInner);
export default WebformWizardPageInner;
